import React from 'react';
import CustomButton from '../../../common/components/CustomButton';
import CustomCheckbox from '../../../common/components/CustomCheckbox';
import PopupContainer from '../../../common/components/PopupContainer';

// ボーカル除去の確認（ポップアップ）
export default function KaraokeUploadForm1VocalRemovalConfirmPopup({
  onDone,
  onCancel,
} : {
  onCancel: () => void,
  onDone: () => void,
}) {
  const [check1, setCheck1] = React.useState(false);
  const [check2, setCheck2] = React.useState(false);
  const [check3, setCheck3] = React.useState(false);
  const [check4, setCheck4] = React.useState(false);
  return (
    <PopupContainer title="ボーカル除去の注意事項" onClose={() => onCancel()}>
      <div className="list__body">
        <p>
          「歌なし音源」をお持ちでない場合は、ご提出いただく「歌あり音源」にボーカル除去の加工をして使用します。
          それがカラオケ店で再生されます。
          <br />
          <br />
          以下の点をあらかじめご了承ください。
        </p>
        <br />
        <p className="top_line" />
        <br />
        <dl>
          <CustomCheckbox
            checked={check1}
            setChecked={(checked) => setCheck1(checked)}
          >
            加工後もボーカルが薄く残ったり、伴奏の音質に変化がある場合があります。
          </CustomCheckbox>
        </dl>
        <dl>
          <CustomCheckbox
            checked={check2}
            setChecked={(checked) => setCheck2(checked)}
          >
            加工した音源を配信前にご確認いただくことはできません。また、もし音質にご納得いただけない場合でも返金はできません。
          </CustomCheckbox>
        </dl>
        <dl>
          <CustomCheckbox
            checked={check3}
            setChecked={(checked) => setCheck3(checked)}
          >
            ノイズが多いなど音質が悪い場合は配信できないことがあります。
          </CustomCheckbox>
        </dl>
        <dl>
          <CustomCheckbox
            checked={check4}
            setChecked={(checked) => setCheck4(checked)}
          >
            加工した音源データをお渡しすることはできません。
          </CustomCheckbox>
        </dl>
        <ul>
          <li className="bt">
            <CustomButton type="cancel-split" onClick={() => onCancel()}>戻る</CustomButton>
            <CustomButton type="default-split" disabled={!check1 || !check2 || !check3 || !check4} onClick={() => onDone()}>了承して次へ</CustomButton>
          </li>
        </ul>
      </div>
    </PopupContainer>
  );
}
